module.exports = __webpack_public_path__ + "img/lk-menu-arrow.a0844a96.svg";